import type { Meta, StoryFn } from '@storybook/react';
import type { PropsWithChildren } from 'react';

import { Attention } from './Attention';

const codeString = '<Attention>{message}</Attention>';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/Attention',
  component: Attention,
  parameters: {
    inspectComponent: Attention,
    codeString: codeString,
  },
} as Meta<PropsWithChildren>;

const Template: StoryFn<PropsWithChildren> = (args) => <Attention {...args}>Example Attention</Attention>;

export const AttentionExample = Template.bind({});
AttentionExample.args = {};
